export default [
  {
    path: 'relatorios/novo-gecom',
    name: 'novo-gecom',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Gecom',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Novo Gecom' },
      ]
    }
  },
]